export enum BenchmarkMosaicSize {
  /** Wide cells that read as a strip across the top of a card. */
  Card = 'card',
  /** A small square thumbnail that sits inline next to text. */
  Thumbnail = 'thumbnail',
}

/** A mosaic image: its url, or its url with another to show when that one fails to load. */
export type BenchmarkMosaicUrl = string | { url: string; fallbackUrl?: string };

export interface BenchmarkMosaicProps {
  /**
   * The benchmark name; keys the cells and names the mosaic for assistive tech
   */
  name: string;
  /**
   * Up to four thumbnail URLs, each optionally with a fallback; missing cells, and cells whose URLs all fail, render
   * empty
   */
  urls?: BenchmarkMosaicUrl[];
  /**
   * Whether to render skeleton cells instead of images
   *
   * @default false
   */
  isLoading?: boolean;
  /**
   * The mosaic layout
   *
   * @default BenchmarkMosaicSize.Card
   */
  size?: BenchmarkMosaicSize;
  /**
   * Additional classes for the grid
   */
  className?: string;
}
